"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
const _ = __importStar(require("lodash"));
const vue_property_decorator_1 = require("vue-property-decorator");
const vue_class_component_1 = require("vue-class-component");
const core_1 = require("@integro/core");
(0, core_1.addRoute)({
    name: "contracts",
    path: "/contracts",
    component: "Contracts"
});
let Contracts = class Contracts extends (0, vue_class_component_1.mixins)(core_1.UserComponentMixin) {
    componentMetadata = {
        kind: "page",
    };
    beforeCreate() {
        this.$$cache_dsParams = new core_1.ComponentValueCache(this, "dsParams", "Contracts.dsParams");
    }
    size;
    onSize(newValue, oldValue) {
        if (_.isEqual(newValue, oldValue))
            return;
        this.loadDataThrottled("size");
    }
    selectedItems;
    dsParams;
    ds;
    async $$load_ds() {
        return this.$fn.slickDataSource('integro_api/list_contract', { parameters: () => this.dsParams });
    }
    ux;
    b_7315092382398562_modalBindings;
    b_2248226175642056_columnDefaults;
    b_2248226175642056_columns;
    dataMembers = ['selectedItems', 'dsParams', 'ds', 'ux', 'b_7315092382398562_modalBindings', 'b_2248226175642056_columnDefaults', 'b_2248226175642056_columns'];
    data() {
        return {
            ...this.mixinData(),
            actions: this.getActions(),
            ...{
                selectedItems: [],
                dsParams: {
                    skip_archived: true,
                },
                ds: null,
                ux: null,
                b_7315092382398562_modalBindings: {
                    size: "sm",
                },
                b_2248226175642056_columnDefaults: {
                    sortable: true,
                    filterable: true,
                    resizable: true,
                },
                b_2248226175642056_columns: [{
                        field: "contract_number",
                        name: this.$fn.pgettext("Contracts", "Contract number"),
                        type: "command",
                        formatter: {
                            name: "routeLink",
                            to: "contract",
                            params: {
                                id: "id",
                            },
                        },
                    },
                    {
                        field: "contract_type",
                        name: this.$fn.pgettext("Contracts", "Type"),
                        formatter: {
                            name: "chain",
                            mode: "mapReduce",
                            formatters: [{
                                    name: "gettext",
                                    context: "ContractTypes",
                                    conversion: "StartCase",
                                    filterInput: true,
                                },
                                {
                                    name: "badge",
                                    variantMapSource: "fieldValue",
                                    variantmap: {
                                        rental: "contract-type--rental",
                                        vendor: "contract-type--vendor",
                                        rental_agreement: "contract-type--rental_agreement",
                                        service: "contract-type--service",
                                        parking: "contract-type--parking",
                                        unknown: "contract-type--unknown",
                                    },
                                },
                            ],
                        },
                    },
                    {
                        field: "status",
                        name: this.$fn.pgettext("Contracts", "Status"),
                        formatter: {
                            name: "chain",
                            mode: "mapReduce",
                            formatters: [{
                                    name: "gettext",
                                    context: "ContractStatus",
                                    conversion: "StartCase",
                                    filterInput: true,
                                },
                                {
                                    name: "badge",
                                    variantMapSource: "fieldValue",
                                    variantmap: {
                                        draft: "light",
                                        approved: "success",
                                        signed: "success",
                                        active: "primary",
                                        ended: "warning",
                                        terminated: "warning",
                                        rescinded: "danger",
                                        archived: "light",
                                    },
                                },
                            ],
                        },
                    },
                    {
                        field: "rental_data",
                        name: this.$fn.pgettext("Contracts", "Rental"),
                        type: "command",
                        formatter: {
                            name: "chain",
                            mode: "mapReduce",
                            formatters: [{
                                    name: "template",
                                    engine: "hb",
                                    format: "<span>\n\
  {{~#if $value }}\n\
    <strong>{{ $value.name }}</strong>\n\
    {{~#if $value.house_number }} | {{ $value.house_number }}{{/if }}\n\
    {{~#if $value.area }} ({{$value.area}}{{$value.unit_of_area}}){{/if }}\n\
  {{~/if }}\n\
</span>\n\
",
                                },
                                {
                                    name: "routeLink",
                                    to: "rental",
                                    navigateOnIconClick: true,
                                    params: {
                                        id: "rental_id",
                                    },
                                },
                            ],
                        },
                    },
                    {
                        field: "company_name",
                        name: this.$fn.pgettext("Contracts", "Lessor"),
                        type: "command",
                        formatter: {
                            name: "routeLink",
                            to: "company",
                            navigateOnIconClick: true,
                            params: {
                                id: "company_id",
                            },
                        },
                    },
                    {
                        field: "counterparty_name",
                        name: this.$fn.pgettext("Contracts", "Tenant"),
                        type: "command",
                        formatter: {
                            name: "routeLink",
                            to: "company",
                            navigateOnIconClick: true,
                            params: {
                                id: "counterparty_id",
                            },
                        },
                    },
                    {
                        field: "revision_number",
                        name: this.$fn.pgettext("Contracts", "Version"),
                    },
                    {
                        field: "revision_date",
                        name: this.$fn.pgettext("Contracts", "Revision date"),
                        formatter: {
                            name: "date",
                        },
                    },
                    {
                        field: "contract_date",
                        name: this.$fn.pgettext("Contracts", "Contract date"),
                        formatter: {
                            name: "date",
                        },
                    },
                    {
                        field: "valid_from",
                        name: this.$fn.pgettext("Contracts", "Valid From"),
                        formatter: {
                            name: "date",
                        },
                    },
                    {
                        field: "valid_to",
                        name: this.$fn.pgettext("Contracts", "Valid To"),
                        formatter: {
                            name: "date",
                        },
                    },
                    {
                        field: "next_indexation_date",
                        name: this.$fn.pgettext("Contracts", "Next indexation"),
                        formatter: {
                            name: "date",
                        },
                    },
                    {
                        field: "termination_date",
                        name: this.$fn.pgettext("Contracts", "Termination date"),
                        formatter: {
                            name: "date",
                        },
                    },
                    {
                        field: "termination_effective_date",
                        name: this.$fn.pgettext("Contracts", "Termination effective date"),
                        formatter: {
                            name: "date",
                        },
                    },
                    {
                        field: "folder_number",
                        name: this.$fn.pgettext("Contracts", "Folder number"),
                    },
                    {
                        field: "property_units",
                        name: this.$fn.pgettext("Contracts", "Property units"),
                        toolTip: this.$fn.pgettext("Contracts", "Property units"),
                        formatter: {
                            name: "chain",
                            mode: "mapReduce",
                            separator: ", ",
                            formatterContext: "item",
                            formatters: [{
                                    name: "getvalue",
                                    opts: {
                                        field: "code",
                                        source: "value",
                                    },
                                },
                            ],
                        },
                    },
                    {
                        field: "created_at",
                        name: this.$fn.pgettext("BrowserColumn", "Create time"),
                        formatter: "datetime",
                    },
                ],
            },
        };
    }
    get document() {
        if (this.loaded) {
            return {
                title: this.$fn.gettext("Contracts"),
                icon: this.$config.contract.icon,
            };
        }
        return null;
    }
    async act_7315092382398562_closeModal_3922_getActionArgs($event) {
        return {
            name: this.modalName,
            result: {
                close: true,
                cancel: true,
            },
        };
    }
    async evh_7315092382398562_close(event, scope) {
        return await this.actions.evh_7315092382398562_close.executeFromDOM(this, event, scope);
    }
    async act_2248226175642056_setData_3924_getActionArgs($event) {
        return {
            path: "selectedItems",
            value: this.$refs.grid.getSelectedItems(),
            resolve: false,
            noTouchLastLoaded: false,
            noTakeSnapshot: false,
        };
    }
    async evh_2248226175642056_selectedRowsChanged(event, scope) {
        return await this.actions.evh_2248226175642056_selectedRowsChanged.executeFromDOM(this, event, scope);
    }
    async act_4440454779651433_showModal_3926_getActionArgs($event) {
        return {
            name: "CreateContract",
        };
    }
    async evh_4440454779651433_click(event, scope) {
        return await this.actions.evh_4440454779651433_click.executeFromDOM(this, event, scope);
    }
    actions;
    getActions() {
        const act_7315092382398562_closeModal_3922 = new core_1.actions.CloseModalAction({
            actionArgs: this.act_7315092382398562_closeModal_3922_getActionArgs,
            events: [],
        });
        const evh_7315092382398562_close_3921 = new core_1.actions.EventHandlerImpl({
            action: act_7315092382398562_closeModal_3922,
            event: "close",
            displayName: "closeModal",
        });
        const evh_7315092382398562_close = new core_1.actions.EventHandlerGroup({
            handlers: [evh_7315092382398562_close_3921],
        });
        const act_2248226175642056_setData_3924 = new core_1.actions.SetDataAction({
            actionArgs: this.act_2248226175642056_setData_3924_getActionArgs,
            events: [],
        });
        const evh_2248226175642056_selectedRowsChanged_3923 = new core_1.actions.EventHandlerImpl({
            action: act_2248226175642056_setData_3924,
            event: "selectedRowsChanged",
            displayName: "setData",
        });
        const evh_2248226175642056_selectedRowsChanged = new core_1.actions.EventHandlerGroup({
            handlers: [evh_2248226175642056_selectedRowsChanged_3923],
        });
        const act_4440454779651433_showModal_3926 = new core_1.actions.ShowModalAction({
            actionArgs: this.act_4440454779651433_showModal_3926_getActionArgs,
            events: [],
        });
        const evh_4440454779651433_click_3925 = new core_1.actions.EventHandlerImpl({
            action: act_4440454779651433_showModal_3926,
            event: "click",
            displayName: "showModal",
        });
        const evh_4440454779651433_click = new core_1.actions.EventHandlerGroup({
            handlers: [evh_4440454779651433_click_3925],
        });
        return {
            act_7315092382398562_closeModal_3922,
            evh_7315092382398562_close_3921,
            evh_7315092382398562_close,
            act_2248226175642056_setData_3924,
            evh_2248226175642056_selectedRowsChanged_3923,
            evh_2248226175642056_selectedRowsChanged,
            act_4440454779651433_showModal_3926,
            evh_4440454779651433_click_3925,
            evh_4440454779651433_click,
        };
    }
};
__decorate([
    (0, vue_property_decorator_1.Prop)({
        type: String,
        default: "md",
    }),
    __metadata("design:type", String)
], Contracts.prototype, "size", void 0);
__decorate([
    (0, vue_property_decorator_1.Watch)('size'),
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object, Object]),
    __metadata("design:returntype", void 0)
], Contracts.prototype, "onSize", null);
Contracts = __decorate([
    (0, vue_property_decorator_1.Component)()
], Contracts);
exports.default = Contracts;
vue_property_decorator_1.Vue.component("Contracts", Contracts);
